import { Avatar } from 'antd';
import { type UserAvatarSpecsFragment } from '../api/fragments/UserAvatarSpecs';

export type UserAvatarProps = { user: UserAvatarSpecsFragment };

const avatarStyle = { color: '#f56a00', backgroundColor: '#fde3cf' };

const UserAvatar = ({ user }: UserAvatarProps) => (
    <Avatar alt="avatar" size="small" src={user.profileImage?.url} style={avatarStyle}>
        {user.displayName[0].toUpperCase()}
    </Avatar>
);

export default UserAvatar;
